export const DEFAULT_MESSAGE_CREATED_CONDITION = [
  {
    attribute_key: 'message_type',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_CONVERSATION_CONDITION = [
  {
    attribute_key: 'browser_language',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_OTHER_CONDITION = [
  {
    attribute_key: 'status',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_ACTIONS = [
  {
    action_name: 'assign_agent',
    action_params: [],
  },
];

// Default condition for ticket events
export const DEFAULT_TICKET_CONDITION = [
  {
    attribute_key: 'ticket_status',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

// Default actions for ticket events
export const DEFAULT_TICKET_ACTIONS = [
  {
    action_name: 'update_ticket_status',
    action_params: [],
  },
];

// Default condition for service order events
export const DEFAULT_SERVICE_ORDER_CONDITION = [
  {
    attribute_key: 'order_type',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

// Default actions for service order events
export const DEFAULT_SERVICE_ORDER_ACTIONS = [
  {
    action_name: 'update_ticket_status',
    action_params: [],
  },
];

export const MESSAGE_CONDITION_VALUES = [
  {
    id: 'incoming',
    name: 'Incoming',
    i18nKey: 'INCOMING',
  },
  {
    id: 'outgoing',
    name: 'Outgoing',
    i18nKey: 'OUTGOING',
  },
];

export const PRIORITY_CONDITION_VALUES = [
  {
    id: 'nil',
    name: 'None',
    i18nKey: 'NONE',
  },
  {
    id: 'low',
    name: 'Low',
    i18nKey: 'LOW',
  },
  {
    id: 'medium',
    name: 'Medium',
    i18nKey: 'MEDIUM',
  },
  {
    id: 'high',
    name: 'High',
    i18nKey: 'HIGH',
  },
  {
    id: 'urgent',
    name: 'Urgent',
    i18nKey: 'URGENT',
  },
];

// Ticket Status Options
export const TICKET_STATUS_VALUES = [
  { id: 'open', name: 'Open', i18nKey: 'OPEN' },
  { id: 'in_progress', name: 'In Progress', i18nKey: 'IN_PROGRESS' },
  { id: 'escalated', name: 'Escalated', i18nKey: 'ESCALATED' },
  { id: 'waiting_client', name: 'Waiting Client', i18nKey: 'WAITING_CLIENT' },
  {
    id: 'waiting_internal',
    name: 'Waiting Internal',
    i18nKey: 'WAITING_INTERNAL',
  },
  { id: 'resolved', name: 'Resolved', i18nKey: 'RESOLVED' },
  { id: 'closed', name: 'Closed', i18nKey: 'CLOSED' },
  { id: 'cancelled', name: 'Cancelled', i18nKey: 'CANCELLED' },
];

// Ticket Priority Options (without 'None')
export const TICKET_PRIORITY_VALUES = [
  { id: 'low', name: 'Low', i18nKey: 'LOW' },
  { id: 'medium', name: 'Medium', i18nKey: 'MEDIUM' },
  { id: 'high', name: 'High', i18nKey: 'HIGH' },
  { id: 'urgent', name: 'Urgent', i18nKey: 'URGENT' },
];

// Ticket Category and Subcategory - loaded dynamically from API
// These are placeholder exports for backwards compatibility
// Actual values should be fetched from TicketCategoriesAPI
export const TICKET_CATEGORY_VALUES = [];
export const TICKET_SUBCATEGORY_VALUES = [];

// Ticket Channel Options
export const TICKET_CHANNEL_VALUES = [
  { id: 'whatsapp', name: 'WhatsApp', i18nKey: 'WHATSAPP' },
  { id: 'web_chat', name: 'Web Chat', i18nKey: 'WEB_CHAT' },
  { id: 'email', name: 'Email', i18nKey: 'EMAIL' },
  { id: 'phone', name: 'Phone', i18nKey: 'PHONE' },
  { id: 'in_person', name: 'In Person', i18nKey: 'IN_PERSON' },
  { id: 'mobile_app', name: 'Mobile App', i18nKey: 'MOBILE_APP' },
  { id: 'app_cea', name: 'App CEA', i18nKey: 'APP_CEA' },
  { id: 'whatsapp_gob', name: 'WhatsApp Gob', i18nKey: 'WHATSAPP_GOB' },
];

// Order Type Options (for Service Orders)
export const ORDER_TYPE_VALUES = [
  { id: 'installation', name: 'Installation', i18nKey: 'INSTALLATION' },
  { id: 'repair', name: 'Repair', i18nKey: 'REPAIR' },
  { id: 'inspection', name: 'Inspection', i18nKey: 'INSPECTION' },
  { id: 'maintenance', name: 'Maintenance', i18nKey: 'MAINTENANCE' },
];

// Order Status Options (for Service Orders)
export const ORDER_STATUS_VALUES = [
  { id: 'draft', name: 'Draft', i18nKey: 'DRAFT' },
  { id: 'ready', name: 'Ready', i18nKey: 'READY' },
  { id: 'dispatched', name: 'Dispatched', i18nKey: 'DISPATCHED' },
  { id: 'en_route', name: 'En Route', i18nKey: 'EN_ROUTE' },
  { id: 'on_site', name: 'On Site', i18nKey: 'ON_SITE' },
  { id: 'field_complete', name: 'Field Complete', i18nKey: 'FIELD_COMPLETE' },
  { id: 'cancelled', name: 'Cancelled', i18nKey: 'CANCELLED' },
];

// Order Class Options (for Service Orders)
export const ORDER_CLASS_VALUES = [
  { id: 'service_order', name: 'Service Order', i18nKey: 'SERVICE_ORDER' },
  { id: 'work_order', name: 'Work Order', i18nKey: 'WORK_ORDER' },
];
